import antdData from 'antd/lib/locale-provider/ca_ES'
import localeData from 'react-intl/locale-data/ca'

const messages = {
  'sec1.header1': 'DESCOBREIX LA TRAÇABILITAT ',
  'sec1.header2': 'DE LA TEVA JOIA TOUS',
  'sec1.text':
    'Parlar de sostenibilitat és parlar de traçabilitat. A TOUS, som pioners en presentar la traçabilitat completa d’una joia, des de la companyia minera fins que arriba a tu. Amb Tracemark, tens la certesa que la teva joia és 100 % ètica i sostenible, des del principi fins a la fi.',

  'sec2.description': 'Descripció',
  'sec2.button': 'ID DIGITAL',

  'rawMaterials.header': 'Matèries primeres',
  'rawMaterials.header.text': 'Or i diamants de proveïment responsable.',

  'rawMaterials.sec1.header1': 'Or 100 % ètic i ',
  'rawMaterials.sec1.header2': 'reciclat',
  'rawMaterials.sec1.text1':
    'Aquesta peça està feta amb or 100 % ètic, reciclat i d’origen responsable, provinent de refineries que només treballen amb or CoC (Cadena de Custòdia). La norma de RJC (Responsible Jewellery Council) Chain of Custody garanteix que l’or s’ha extret de manera sostenible i seguint el Codi de Pràctiques de RJC.',
  'rawMaterials.sec1.text2':
    'L’or, utilitzat en aquesta peça de joieria, prové de fonts que han estat verificades com que compleixen amb les millors pràctiques ambientals internacionals i els estàndards socials reconeguts arreu del món.',
  'rawMaterials.sec1.notTraceableMaterial': 'Material sense traçabilitat Tracemark:',

  'rawMaterials.sec2.header1': 'Diamants',
  'rawMaterials.sec2.header2': 'traçables',
  'rawMaterials.sec2.header3': 'd’origen responsable',
  'rawMaterials.sec2.text1.1': 'Els diamants d’aquesta joia provenen de la companyia minera ',
  'rawMaterials.sec2.text1.2':
    ', membre certificat de RJC o DeBeers Sightholder, que garanteix el proveïment responsable i el compliment de les pràctiques sostenibles i ètiques al llarg de tota la cadena de subministrament.',
  'rawMaterials.sec2.text2': 'El país d’origen dels diamants és ',
  'rawMaterials.sec2.text3':
    'Cada diamant està verificat pel seu propi Certificat de Procés Kimberly, que verifica la seva autenticitat, procedència i extracció ètica.',
  'rawMaterials.sec2.text4.1': 'La',
  'rawMaterials.sec2.text4.2': 'Certificació del Procés de Kimberley',
  'rawMaterials.sec2.text4.3':
    'imposa requisits extensos als seus membres per permetre’ls certificar els enviaments dels diamants en brut com a "lliures de conflictes" i evitar que els diamants en conflicte entrin en el comerç legítim.',

  'fabricationProcess.header1': 'Procés de fabricació:',
  'fabricationProcess.header2': 'l’art de la manufactura',

  'fabricationProcess.text1':
    'La manufactura d’una joia comença inspirant-se en una emoció o idea que es converteix en disseny. Experts joiers converteixen aquest esbós en una joia única a través d’un procés de fabricació que recull la tradició de l’ofici i incorpora tècniques de producció innovadores. Aquesta peça es fabrica a Còrdova, al sud d’Espanya. Des del modelatge, la fosa i el repassat, fins a l’encastat i el poliment, els nostres artesans cordovesos van donant forma a aquesta joia amb la passió de l’ofici i l’experta dedicació.',
  'fabricationProcess.text2':
    'Tota la documentació i informació sobre la traçabilitat d’aquesta joia ha estat verificada per un auditor extern acreditat per RJC.',
  'fabricationProcessTousHav.text3':
    "La fabricació d'una joieria comença amb la inspiració d'una emoció o idea que després es converteix en disseny. Els joiers experts converteixen aquest disseny en una peça única de joieria mitjançant un procés de fabricació que reflecteix la tradició de l'artesania alhora que incorporen tècniques de producció innovadores. Aquesta peça està feta a Bombai. Des del modelatge i fosa fins a l'acabat, muntatge i polit, els nostres artesans donen forma a aquesta peça amb la passió de la seva professió i la seva dedicació experta.",

  certificates: 'Certificats',
  download: 'DESCARREGAR',

  'digitalPass.header': 'Obtenga su Tracemark ID',
  'digitalPass.step1': 'Autentifique su joya',
  'digitalPass.step2': 'Genere su Tracemark ID',

  'digitalPass.uniqueCode':
    'Código alfanumérico único como aparece grabado en su joya y en la etiqueta de la misma',
  'digitalPass.Authenticate': 'Autentificar',

  'digitalPass.personalDetails': 'Detalles personales',
  'digitalPass.email': 'email',
  'digitalPass.firstName': 'Nombre',
  'digitalPass.lastName': 'Apellido',
  'digitalPass.password.text1': 'Establezca una contraseña',
  'digitalPass.password.text2':
    'Establezca una contraseña para acreditar la propiedad de su joya y obtener su Tracemark ID.',
  'digitalPass.password': 'Contraseña',
  'digitalPass.confirmPassword': 'Confirmar contraseña',
  'digitalPass.generateTracemarkIDButton': 'Obtener Tracemark ID',

  'digitalPass.notificationHeader': 'Descargando Tracemark ID',
  'digitalPass.notificationText':
    'También recibirá su Tracemark ID por email. Por favor, descárguelo utilizando su teléfono móvil para guardarlo automáticamente en formato Passbook.',

  'digitalPass.termsAndCondition1': 'He leído y acepto de forma expresa la',
  'digitalPass.termsAndCondition2':
    'de “TRACEABLE LUXURY SERVICES, S.L.” y las condiciones del tratamiento de mis datos personales.',

  /* ----------- Start Delete TracemarkID Popup ------------- */

  'deleteTracemarkID.link': 'Restablecer la propiedad de esta joya y liberar Tracemark ID',
  'deleteTracemarkID.modal.header': 'Restablecido Tracemark ID',

  'deleteTracemarkID.step1.password': 'Introduzca su contraseña',
  'deleteTracemarkID.step1.button': 'Validar',
  'deleteTracemarkID.step1.forgotPasswordLink': 'He olvidado mi contraseña',

  'deleteTracemarkID.step2.resetText':
    'Escriba RESET para restablecer la propiedad de su Tracemark ID en caso de devolución o entrega a un nuevo propietario.',

  'deleteTracemarkID.step3.success':
    'Gracias. La propiedad y el Tracemark ID para esta joya se han restablecido.',

  /* ----------- End Delete TracemarkID Popup ------------- */

  'downloadCertificate.text1':
    'Para descargarte el certificado de Tracemark de esta pieza, por favor introduce la contraseña utilizada para registrar la joya. Esta es la contraseña que habilitaste para obtener tu Tracemark ID.',
  'downloadCertificate.text2':
    'Si no has registrado tu joya, puedes hacerlo directamente desde el panel de trazabilidad, junto al apartado de Tracemark ID.',

  'downloadCertificate.success':
    'En breve recibirás un correo electrónico con el certificado de Tracemark de esta joya adjunto, a la dirección de correo utilizada para registrar su propiedad.',

  'downloadCertificate.title': 'Descargar certificado',
  'Consumer.download': 'Descargar',

  /* ----------- Start Tous version 2(v2) changes ------------- */

  'rawMaterials.sec2.v2.text1':
    'Els diamants d’aquesta joia provenen de talladors de diamants membres de De Beers Sightholder, garantint el proveïment responsable i el compliment de les pràctiques sostenibles i ètiques al llarg de tota la cadena de subministrament.',
  'rawMaterials.sec2.v2.text2':
    'Cada diamant està verificat pel seu propi Certificat de Procés Kimberly, que verifica la seva autenticitat, procedència i extracció ètica. ',
  'rawMaterials.sec2.v2.text3':
    'La Certificació del Procés de Kimberley imposa requisits extensos als seus membres per permetre’ls certificar els enviaments dels diamants en brut com a "lliures de conflictes" i evitar que els diamants en conflicte entrin en el comerç legítim.',
  /* ----------- End Tous version 2(v2) changes ------------- */

  /* ----------- Start Tous Platinum version 2(v2) changes ------------- */

  'tousPlatinumPanel.rawMaterials.sec1.header1': 'PLATÍ',
  'tousPlatinumPanel.rawMaterials.sec1.header2': '100% ÈTIC',
  'tousPlatinumPanel.rawMaterials.sec1.text1':
    "Aquesta joia ha estat elaborada amb platí 100% ètic i d'origen responsable, obtingut de refinadores europees acreditades pel Responsible Jewellery Council (RJC). Aquestes refinadores compleixen amb les certificacions de Codi de Pràctiques (CoP) i Cadena de Custòdia (CoC), garantint la sostenibilitat del metall.",
  'tousPlatinumPanel.rawMaterials.sec1.text2':
    'El platí utilitzat prové de fonts verificades que compleixen amb els estàndards ambientals i socials més alts reconeguts a nivell internacional, assegurant un impacte positiu en totes les etapes de la seva producció.',

  'tousPlatinumPanel.rawMaterials.sec2.header1': 'DIAMANTS DE',
  'tousPlatinumPanel.rawMaterials.sec2.header2': 'LABORATORI TRAÇABLES I',
  'tousPlatinumPanel.rawMaterials.sec2.header3': 'RESPONSABLEMENT CREATS',
  'tousPlatinumPanel.rawMaterials.sec2.text1':
    "Els diamants de laboratori (LGD) d'aquesta peça de joieria provenen de productors i talladors de diamants, membres verificats del marc de SMETA (Sedex Members Ethical Trade Audit). Aquesta afiliació garanteix que totes les operacions, incloent-hi les condicions laborals i les pràctiques ambientals, compleixen els estàndards més alts de conducta empresarial ètica i sostenible al llarg de tota la cadena de subministrament.",
  'tousPlatinumPanel.rawMaterials.sec2.text2':
    'En associar-nos amb entitats que compleixen els requisits de SMETA, assegurem que tota la nostra cadena de subministrament estigui alineada amb les millors pràctiques en matèria de sostenibilitat i responsabilitat.',
  'tousPlatinumPanel.rawMaterials.sec2.text3':
    'A més, els nostres proveïdors compleixen íntegrament amb els criteris de Governança Ambiental, Social i Corporativa (ESG), reafirmant així el nostre compromís amb un proveïment ètic i sostenible.',
  /* ----------- End Tous Platinum version 2(v2) changes ------------- */

  /* ----------- Start Dynamic Panel Digital pass ------------- */
  'dynamicPanelsDigitalPass.header': 'Obtingui el seu Passaport Tracemark',
  'dynamicPanelsDigitalPass.generateTracemarkIDButton': 'Obtingui el Passaport Tracemark',

  'dynamicPanelsDigitalPass.uniqueCode':
    'Insereixi el codi alfanumèric que apareix a la seva Etiqueta Tracemark',

  'dynamicPanelsDigitalPass.email': 'Email',
  'dynamicPanelsDigitalPass.email2': 'Email',
  'dynamicPanelsDigitalPass.firstName': 'Nom',
  'dynamicPanelsDigitalPass.lastName': 'Cognom',
  'dynamicPanelsDigitalPass.password': 'Contrasenya',

  'dynamicPanelsDigitalPass.notificationHeader': "S'està baixant el vostre ID de Tracemark",
  'dynamicPanelsDigitalPass.notificationText':
    "També us l'hem enviat a través de l'adreça de correu electrònic proporcionada. Obriu l'identificador de Tracemark adjunt al vostre telèfon intel·ligent per desar-lo a la vostra cartera digital.",

  'dynamicPanelsDigitalPass.termsAndCondition1': 'He llegit la',
  'dynamicPanelsDigitalPass.termsAndCondition2': ' política de privacitat ',
  'dynamicPanelsDigitalPass.termsAndCondition3':
    "de 'TRACEABLE LUXURY SERVICES, S.L.' i accepto expressament les condicions per al tractament de les meves dades personals.",

  'dynamicPanelsDigitalPass.resetOwnership': 'Restablir la propietat del Passaport Tracemark.',
  'dynamicPanelsDigitalPass.password.text':
    'Si us plau, insereixi la seva contrasenya per recuperar el seu Passaport Tracemark.',
  'dynamicPanelsDigitalPass.forgotPassword': '¿Ha oblidat la contrasenya?',

  'dynamicPanelsDigitalPass.step1': 'Autentiqueu la vostra peça',
  'dynamicPanelsDigitalPass.step2': 'Genera el passaport Tracemark',
  'dynamicPanelsDigitalPass.Authenticate': 'Autenticar-se',
  'dynamicPanelsDigitalPass.personalDetails': 'Dades personals',
  'dynamicPanelsDigitalPass.password.text1': 'Estableix una contrasenya',
  'dynamicPanelsDigitalPass.password.text2':
    "Si us plau, estableix una contrasenya per registrar la teva propietat d'aquesta joia i assegurar el teu passaport Tracemark:",
  'dynamicPanelsDigitalPass.confirmPassword': 'Confirmeu la contrasenya',

  'dynamicPanelsDigitalPass.required.uniqueCode': 'Introduïu un codi únic',
  'dynamicPanelsDigitalPass.required.name': 'Introduïu el nom',
  'dynamicPanelsDigitalPass.required.lastName': 'Introduïu el cognom',
  'dynamicPanelsDigitalPass.required.email': 'Introduïu el correu electrònic',
  'dynamicPanelsDigitalPass.required.validEmail': 'Introduïu un correu electrònic vàlid',
  'dynamicPanelsDigitalPass.required.terms': 'Accepteu els termes i condicions',
  'dynamicPanelsDigitalPass.required.password': 'Introduïu la contrasenya',
  'dynamicPanelsDigitalPass.required.confirmPassword': 'Introduïu la contrasenya de confirmació',
  'dynamicPanelsDigitalPass.required.matchPassword':
    'La contrasenya nova i la contrasenya de confirmació no coincideixen',
  /* ----------- End  Dynamic Panel Digital pass ------------- */
}

export default {
  locale: 'ca-ES',
  antdData,
  localeData,
  messages,
}
